require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./affaires-professorales-0-2-3.json") })
        }
      }, "path---affaires-professorales-0-2-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---affaires-professorales-0-2-3!./.cache/json/affaires-professorales-0-2-3.json
// module id = 321
// module chunks = 231608221292675